var exports = {
  "kL": "GameActivityDisplay.module__container___SEtKRy",
  "Eb": "GameActivityDisplay.module__activity___SEtKRy",
  "rf": "GameActivityDisplay.module__body___SEtKRy",
  "Kk": "GameActivityDisplay.module__icon___SEtKRy",
  "zH": "GameActivityDisplay.module__details___SEtKRy",
  "Pf": "GameActivityDisplay.module__label___SEtKRy",
  "UU": "GameActivityDisplay.module__name___SEtKRy",
  "p0": "GameActivityDisplay.module__duration___SEtKRy",
  "c5": "GameActivityDisplay.module__durationIcon___SEtKRy",
};

module.exports = exports;
